import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InvoiceStatus } from '@galaxy/billing';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, Subscription } from 'rxjs';
import { InvoiceService } from '../invoice.service';
import { NotificationType } from '../shared/notification';

interface DialogData {
  merchantId: string;
  invoiceId: string;
}

@Component({
  selector: 'smb-invoicing-change-invoice-status-dialog',
  templateUrl: './change-invoice-status-dialog.component.html',
  styleUrls: ['./change-invoice-status-dialog.component.scss'],
  standalone: false,
})
export class ChangeInvoiceStatusDialogComponent implements OnInit, OnDestroy {
  invoiceStatus: InvoiceStatus;
  merchantId: string;
  invoiceId: string;
  loading$: Observable<boolean>;
  PaidStatus: InvoiceStatus = InvoiceStatus.PAID;
  VoidStatus: InvoiceStatus = InvoiceStatus.VOID;
  reason: string;

  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangeInvoiceStatusDialogComponent, boolean>,
    private invoiceService: InvoiceService,
    private alertService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.invoiceId = data.invoiceId;
    this.merchantId = data.merchantId;
    this.loading$ = this.invoiceService.loading$;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.invoiceService.notification$.subscribe((notification) => {
        if (notification.type === NotificationType.SUCCESS) {
          this.alertService.openSuccessSnack(notification.message);
        } else {
          this.alertService.openErrorSnack(notification.message);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  changeStatus(): void {
    this.invoiceService
      .changeStatus(this.merchantId, this.invoiceId, this.invoiceStatus, this.reason)
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this.dialogRef.close(isSuccess);
        }
      });
  }
}
